module.exports = __webpack_public_path__ + "img/clogo.f0a079d5.png";